export default __webpack_public_path__ + "./images/cm.6df93358.png";